import { useEffect, useState } from 'react';
import { DataSyncObjectsStore } from '../stores/object/DataSyncObjectsStore';

export function useFetchStores(
  sourceStore: DataSyncObjectsStore | null,
  destinationStore: DataSyncObjectsStore | null
) {
  const [sourceLoaded, setSourceLoaded] = useState(false);
  const [destinationLoaded, setDestinationLoaded] = useState(false);

  useEffect(() => {
    if (sourceStore) {
      sourceStore.fetch()
        .then(() => {
          setSourceLoaded(true);
        });
    }
  }, [sourceStore]);

  useEffect(() => {
    if (destinationStore) {
      destinationStore.fetch()
        .then(() => {
          setDestinationLoaded(true);
        });
    }
  }, [destinationStore]);

  return {loaded: sourceLoaded && destinationLoaded};
}
